import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { AtbHomeService, Model } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { IMyDpOptions } from "mydatepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { environment } from '../../../../environments/environment';
import swal from "sweetalert2";
defineLocale("it", itLocale);
import * as moment from 'moment';

declare var jQuery: any;
@Component({
  selector: "app-hoteliers-permits-signin",
  templateUrl: "./hoteliers-permits-signin.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class HoteliersPermitsSigninComponent implements OnInit {
  baseUrl;
  visibleRequest;

  name;
  counter;
  data;
  permitsBasePath;
  kindPermitsPath;
  permitsPath;
  kindDescription;
  maxStops;
  maxTransit;
  max;
  defaultValuePermits;
  test;
  amount;
  idStructure;
  dataKinds: any[] = new Array();
  permitsList: any[] = new Array();
  pathPayment;
  pathInfoPayment;
  kindPermit= 0;
  datepickerModel: Date;
  categoryCode;
  paymentsData: Model = new Model();
  bsValue = new Date();
  locale = "it";
  @ViewChild("kindForm")
  formStay: NgForm;
  //LORENZ
  isValid
  //S1
   sosta_valida = 0;
   sosta_richiesta_pending= 0;
   puo_aggiungere_sosta = false;
   transito_valido = 0;
   transito_richiesta_pending= 0;
   puo_aggiungere_transito = false;

  profiliFatturazione: any[] = new Array();
  profiliFatturazionePath = "profilifatturazione"
  idProfiloFatturazione = "null";
  idRequestAcquisto;
  viewScegliProfiloFatturazione = false;

  idCustomer = null
  paymentMethods: any[] = new Array();
  paymentMethodPath = "atbpay/payment_method";
  idMetodoPagamento = null;

  modalRef: BsModalRef;
  private subscription: Subscription;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd-mm-yyyy"
  };
  public model1: any;

  constructor(
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService,
    private localeService: BsLocaleService
  ) {
    this.localeService.use(this.locale);
  }

  ngOnInit() {
    this.baseUrl = environment.baseUrl;
    //this.pathInfoPayment = "acquistapermessi";
    this.pathInfoPayment = "acquistapermessiconatbpay";
    this.visibleRequest = false;
    this.name = localStorage.getItem("structureName");

    this.data = JSON.parse(localStorage.getItem("dataPassed"));

    this.maxStops = this.data["maxPermessiSosta"];

    this.maxTransit = this.data["maxPermessiTransito"];

    this.permitsBasePath = "permessituristici";
    this.kindPermitsPath = "tipologiepermessi";
    this.permitsPath = "richiestepermessi";

    this.categoryCode = this.data["codiceCategoria"];
    if (this.categoryCode == null) {
      this.kindDescription = "Sosta";
      this.max = this.maxStops;
      this.counter = this.maxStops;
      //this.kindPermit = "1";
      this.amount = this.maxStops * this.data["costoSosta"];
    } else {
      this.kindDescription = "Transito";
      this.max = this.maxTransit;
      this.counter = this.maxTransit;
      //this.kindPermit = "2";
      this.amount = this.maxTransit * this.data["costoTransito"];
    }

    // this.max = this.maxTransit;

    this.idStructure = this.data["id"];

    this.getListPermits();

    this.kindPermitsList();

    this.getProfiliFatturazione();

    this.getAtbPayPaymentMethods();

    // localStorage.setItem('dataPassed', '')

    this.pathPayment = environment.paymentUrl;
  }

  goToStructure() {
    this.router.navigate(["/hoteliers/structure/structures"]);
  }

  goToProfiliFatturazione() {

  }

  closeRequest() {
    this.visibleRequest = false;
    this.kindPermit = 0;
    this.ngOnInit();
    //this.getListPermits();
  }

  openModal(template: TemplateRef<any>, cssClass: string) {
    if (cssClass) {
      this.modalRef = this.modalService.show(template, { class: cssClass });
    } else {
      this.modalRef = this.modalService.show(template);
    }
  }
  close() {
    this.modalRef.hide();
  }

  goToCalendar() {
    this.router.navigate(["/hoteliers/permits/calendar"]);
  }

  open() {
    jQuery("#sidebar").toggleClass("active");
  }

  openRequest() {
    this.datepickerModel = new Date();
    this.visibleRequest = true;
  }

  add() {
    this.counter = this.counter + 1;

    if (this.kindDescription == "Sosta") {
      this.amount = this.counter * this.data["costoSosta"];
    } else {
      this.amount = this.counter * this.data["costoTransito"];
    }
  }

  remove() {
    this.counter = this.counter - 1;

    if (this.kindDescription == "Sosta") {
      this.amount = this.counter * this.data['costoSosta'];
    } else {
      this.amount = this.counter * this.data['costoTransito'];
    }
  }

  onChangePermit(id) {
    this.kindPermit = id;
    this.amount = 0;

    this.counter = 0;
    if (id == 1) {
      this.max = this.maxStops;
      this.counter = this.maxStops;
      this.amount = this.maxStops * this.data['costoSosta'];
      this.kindDescription = 'Sosta';
    } else {
      this.max = this.maxTransit;
      this.counter = this.maxTransit;
      this.amount = this.maxTransit * this.data['costoTransito'];
      this.kindDescription = 'Transito';
    }
  }

  createRequestPermits() {
    this.spinner.show();
    var request = new Object();

    request['idStruttura'] = this.idStructure;

    if (this.kindDescription == 'Sosta') {
      request['idTipologia'] = 1;
    } else {
      request['idTipologia'] = 2;
    }

    request['numPermessi'] = this.counter;

    request['id'] = null;

    //request['dataInizioValidita'] =  this.atbService.stringToServerFormat( this.formStay.value.inizioValidita.formatted , ' 00:00:00')
    request['dataInizioValidita'] = this.atbService.DataToServerFormat(
      this.datepickerModel,
      ' 00:00:00'
    );

    this.atbService.newObject(request, this.permitsBasePath + '/' + this.permitsPath).subscribe(
      response => {
        if (response.outcome.success === true) {
          swal2('Il permesso è stato richiesto', '', 'success');
          // this.router.navigate(['/hoteliers/structure/structures']);
          //    this.spinner.hide()
          this.spinner.hide();
          this.closeRequest();
        } else {
          //      this.errorMessage = 'Credenziali non valide.';
          swal2('Attenzione', 'Qualcosa è andato storto', 'warning');
          // this.spinner.hide()
          this.spinner.hide();

        }
      },
      error => {
        //   this.logger.log("Error", error, 200);
        //  this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        // this.spinner.hide()
        this.spinner.hide();
      }
    );
  }

  checkValidRequest(permitsList) {


    var maxSost = this.max;
    var counterRequest = 0;
    var counterValidPermits = 0

    for (let p of permitsList) {
      this. isValid = false;
      let currentDate = new Date();
      if (
        /*p.desStato === 'Completata con invio Mail' &&
        p.desTipologia === 'sosta'*/
        p.idStato === 4 &&
        p.idTipologia === 1
      ) {
        //counterValidPermits = counterValidPermits + 1
        // tslint:disable-next-line:radix
        let dataEnd = p.dataFineValidita;
        let dateString = dataEnd;
        let expiredDate = moment(dateString).toDate();

        let currentIntDate = Number(currentDate);
        let expiredIntDate = Number(expiredDate);

        let diffDays = (currentIntDate - expiredIntDate) / (1000 * 60 * 60 * 24);

        if (diffDays > -15) {
          //counterRequest = counterRequest + p.numPermessi;

        } else {
          // S1
          this.sosta_valida = this.sosta_valida + 1;
        }
      }
      if (  p.idTipologia === 1 && (p.idStato == 1 || p.idStato == 2) ) {
        this.sosta_richiesta_pending = this.sosta_richiesta_pending + 1;
      }

      if (
        /*p.desStato === 'Completata con invio Mail' &&
        p.desTipologia === 'transito'*/
        p.idStato === 4 &&
        p.idTipologia === 2
      ) {
        //counterValidPermits = counterValidPermits + 1
        // tslint:disable-next-line:radix
        let dataEnd = p.dataFineValidita;
        let dateString = dataEnd;
        let expiredDate = moment(dateString).toDate();

        let currentIntDate = Number(currentDate);
        let expiredIntDate = Number(expiredDate);

        let diffDays = (currentIntDate - expiredIntDate) / (1000 * 60 * 60 * 24);

        if (diffDays > -15) {
          //counterRequest = counterRequest + p.numPermessi;

        } else {
          // S1
          this.transito_valido = this.transito_valido + 1;
        }
      }
      if (  p.idTipologia === 2 && (p.idStato == 1 || p.idStato == 2) ) {
        this.transito_richiesta_pending = this.transito_richiesta_pending + 1;
      }


    }

    // se c'è la sosta valida quindi stato 4 e validità ok per il numero massimo di soste possibili, non può fare + per la sosta
    if (this.sosta_valida >= 1) {
      this.puo_aggiungere_sosta = false;
    } else {
      // a questo punto controllo se ci sono richieste che sommate alle soste valide fanno il totale disabilito
      this.puo_aggiungere_sosta = true;
      if(this.sosta_valida + this.sosta_richiesta_pending >= 1) {
        this.puo_aggiungere_sosta = false;
      }

      // fix se != ALBERGO allora non può fare sosta, ELIMINATO 19/11/2019
      /*if (this.data["desTipologia"] !== "Albergo") {
        this.puo_aggiungere_sosta = false;
      }*/

    }

    if (this.transito_valido >= 1) {
      this.puo_aggiungere_transito = false;
    } else {
      this.puo_aggiungere_transito = true;
      if(this.transito_valido + this.transito_richiesta_pending >= 1) {
        this.puo_aggiungere_transito = false;
      }
    }

    /*LORENZ
    console.log('VALIDITà ',  counterRequest + " - " + maxSost)
    if (counterRequest > 0) {
        console.log('VALIDITà ',  counterRequest + " - " + maxSost)
        this.isValid = true
    }
    if (permitsList.length === 0) {
        console.log('Lunghezza 0 ')
        this.isValid = true
    }
    if (counterValidPermits === 0) {
        console.log('Lunghezza 0 ')
        this.isValid = true
    }

    if (counterValidPermits < maxSost) {
      this.isValid = true;
      console.log("HO ANCORA QUALCHE PERMESSO DISPONIBILE QUINDI VALIDO", this.isValid)
    }*/
  }

  getListPermits() {
    this.spinner.show();

    this.atbService
      .getListFilter(this.permitsBasePath + '/' + this.permitsPath + '/' + this.idStructure)
      .subscribe(
        response => {
          // Verificare outcome
          if (response.outcome.success === true) {
            this.permitsList = response.results;
            this.checkValidRequest(this.permitsList);
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        error => {
          console.log('Error ', error);
          this.spinner.hide();
        }
      );
  }

  kindPermitsList() {
    this.atbService.getListFilter(this.permitsBasePath + '/' + this.kindPermitsPath).subscribe(
      response => {
        // Verificare outcome
        if (response.outcome.success === true) {
          this.dataKinds = response.results;
        } else {
        }
      },
      error => {
        console.log('Error ', error);
        // this.goToAtbAtHome();
      }
    );
  }


  getProfiliFatturazione() {
    this.atbService.getListFilter(this.permitsBasePath + '/' + this.profiliFatturazionePath).subscribe(
      response => {
        if (response.outcome.success === true) {
          this.profiliFatturazione = response.results;
        } else {

        }
      },
      error => {
        //   this.logger.log("Error", error, 200);
        //  this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        // this.spinner.hide()
        this.spinner.hide();
      }
    );
  }

  viewNomeProfiloFatturazione(dato) {
    if (dato == null) return "Seleziona il profilo";
    let dataSplitted = dato.split(" - ");
    return dataSplitted[1] + " " + dataSplitted[2] + " " +  dataSplitted[3];
  }

  OnChangeValue(id) {
    this.idProfiloFatturazione = id;
  }

  backToRichieste() {
    this.viewScegliProfiloFatturazione = false;
  }

  getAtbPayPaymentMethods() {
    this.atbService.getListFilter(this.paymentMethodPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.idCustomer = response.result.idCustomer
          this.paymentMethods = [...response.result.cards, ...response.result.sepas.map(sepa => ({ ...sepa, type: 'sepa' }))]
        }
        this.spinner.hide()
      },
      (error) => {
        this.spinner.hide()
      }
    );
  }

  getPaymentMethodLabel(paymentMethod) {
    return paymentMethod.type +
      (paymentMethod.last4 ? " (xxxx-xxxx-xxxx-" + paymentMethod.last4 + ")" : "") +
      (paymentMethod.name ? " - " + paymentMethod.name : "") +
      (paymentMethod.expMonth && paymentMethod.expYear ? 
        " (" + (paymentMethod.expMonth < 10 ? "0" + paymentMethod.expMonth : paymentMethod.expMonth) + "/" +
        (paymentMethod.expYear < 100 ? "20" + paymentMethod.expYear : paymentMethod.expYear) + ")" : "");
  }

  payWithAtbPayWithSelectedPaymentMethod() {
    this.payWithAtbPay(this.idMetodoPagamento);
  }

  payWithAtbPayWithOtherPaymentMethod() {
    this.payWithAtbPay();
  }

  payWithAtbPay(idMetodoPagamento = null) {
    this.spinner.show();

    this.atbService.getListFilter(this.permitsBasePath + '/' + this.pathInfoPayment + '/' + this.idRequestAcquisto +
      "?idProfiloFatturazione=" + this.idProfiloFatturazione + "&lingua=IT" +
      (idMetodoPagamento ? "&idMetodoPagamento=" + idMetodoPagamento : "")).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          if (response.result.redirectUrl) {
            setTimeout(() => {
              window.location.href = response.result.redirectUrl
            }, 300);
            this.spinner.hide()
          } else if (response.result.esito) {
            this.spinner.hide()
            this.close()
            this.viewScegliProfiloFatturazione = false;
            this.getListPermits();
          }
        } else {
          this.spinner.hide()
        }
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
        swal('Attenzione', error.message, 'error');
      }
    );
  }

  callPaymentService() {

    this.atbService
    .getListFilter(this.permitsBasePath + '/' + this.pathInfoPayment + '/' + this.idRequestAcquisto + "?idProfiloFatturazione=" + this.idProfiloFatturazione) // PROFILO FATTURATTIVA come query parameter
    .subscribe(
      response => {
        // Verificare outcome
        if (response.outcome.success === true) {
          this.paymentsData.alias = response.result.paramsMap.alias;
          this.paymentsData.codTrans = response.result.paramsMap.codTrans;
          this.paymentsData.cognome = response.result.paramsMap.cognome;
          this.paymentsData.divisa = response.result.paramsMap.divisa;
          this.paymentsData.email = response.result.paramsMap.email;
          this.paymentsData.importo = response.result.paramsMap.importo;
          this.paymentsData.languageId = response.result.paramsMap.languageId;
          this.paymentsData.mac = response.result.paramsMap.mac;
          this.paymentsData.mail = response.result.paramsMap.mail;
          this.paymentsData.nome = response.result.paramsMap.nome;
          this.paymentsData.url = response.result.paramsMap.url;
          this.paymentsData.url_back = response.result.paramsMap.url_back;
          this.paymentsData.urlpost = response.result.paramsMap.urlpost;

          setTimeout(() => {
            // let form: HTMLFormElement  =  (<HTMLFormElement> document.getElementById('nameform'));

            // let form: HTMLForm = document.getElementById('nameform')

            let form: HTMLFormElement = document.getElementById(
              'nameform'
            ) as HTMLFormElement;
            form.submit();
          }, 300);
        } else {
        }
      },
      error => {
        console.log('Error ', error);
        // this.goToAtbAtHome();
      }
    );
  }


  InfoAboutPayment(idRequest, template: TemplateRef<any>) {
    this.viewScegliProfiloFatturazione = true;
    this.idRequestAcquisto = idRequest;
  }


  causeReject(message) {
    swal2('Richiesta Respinta per il seguente motivo:', message, 'warning');
  }

  payPermits(dataPay) {
    this.atbService.pay(dataPay, this.pathPayment).subscribe(
      response => {
        var jsonText = JSON.stringify(response._body);
      },
      error => {
        console.log('Error ', error);
        // this.goToAtbAtHome();
      }
    );
  }

  formatDate(obj) {
    return moment(obj).toISOString();
  }

  getPdfFromtransaction(id) {
    
    window.location.href = environment.restBaseRedirect + 'archivioFatture';
    /*this.atbService
      .getFilePdf('download?id=' + id + '&type=fattpermeturi')
      .subscribe(
        response => {
          if (response) {
            console.log('RISPOSTA', response);

            var blob = new Blob([response], { type: 'application/pdf' });
            var ieEDGE = navigator.userAgent.match(/Edge/g);
            var ie = navigator.userAgent.match(/.NET/g); // IE 11+
            var oldIE = navigator.userAgent.match(/MSIE/g);

            console.log('COSA E?', ieEDGE);
            console.log(blob);
            if (ie || oldIE || ieEDGE) {
              console.log(' EDGE !');
              window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');
            } else {
              console.log(' NON E\' EDGE !');
              var url = window.URL.createObjectURL(blob);
              //   window.open(url);

              //   window.navigator.msSaveOrOpenBlob(blob, 'myPDFdoc.pdf');

              var link = document.createElement('a');
              link.href = url;
              link.download = 'file.pdf';
              link.click();
            }
            swal2('La fattura è stata scaricata', '', 'success');
          } else {
          }
        },
        error => {
          console.log('RISPOSTA', error);
          swal2(
            'Errore',
            'Spiacente, si è verificato un errore tecnico.',
            'error'
          );
        }
      );*/
  }
}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-permits-signin/hoteliers-permits-signin.component.ts